import React from 'react';
import classes from './index.css'

export default function LoadingSpinner() {
    return (
        <div className={classes.spinner}>
            <div className={classes.dot1}></div>
            <div className={classes.dot2}></div>
        </div>
    )
}